import React, { useContext } from 'react';
import { useRouter } from 'next/router';

import { Container } from '@components';
import PageContext from '@contexts/PageContext';
import { checkEnabled, checkValue } from '@components/OptionalFeature';
import styles from './Summary.module.scss';

const Summary = ({ data, id, componentIsAvailable }) => {
  const pageData = useContext(PageContext);
  const router = useRouter();
  const { locale } = router;

  const TitleEnabled = checkEnabled(data?.DisplayOptions,'Title');
  const SubTitleEnabled = checkEnabled(data?.DisplayOptions,'SubTitle');
  const SmallDescriptionEnabled = checkEnabled(data?.DisplayOptions,'SmallDescription');
  const LargeDescriptionEnabled = checkEnabled(data?.DisplayOptions,'LargeDescription');
  const HorsePowerBlurbEnabled =  checkEnabled(data?.DisplayOptions,'HorsePowerBlurb');

  const { HorsePowerBlurb, LargeDescription, SmallDescription, SpecialsBlurb, SubTitle, Title } = pageData.ProductText;

  return (
    componentIsAvailable && (
      <section className={styles.Section} id={id}>
        <Container className={styles.Container}>
          {TitleEnabled && <h2 className={styles.Title}>{Title}</h2>}
          {LargeDescriptionEnabled && <p className={styles.LargeDescription}>{LargeDescription}</p>}
          {SubTitleEnabled && <h4 className={styles.SubTitle}>{SubTitle}</h4>}
          {SmallDescriptionEnabled && <p className={styles.SmallDescription}>{SmallDescription}</p>}
          {HorsePowerBlurbEnabled && (
            <div className={styles.HorsePowerSection}>
              <div className={styles.Content}>
                {locale == 'en' ? 'HorsePower' : 'Puissance'}: {HorsePowerBlurb}
              </div>
            </div>
          )}
        </Container>
      </section>
    )
  );
};

export default Summary;
